import { features } from "@/mocks/data";

export default function FeatureSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            为什么选择大满贯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心优势，为您打造极致游戏体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-2xl p-6 border border-background-200 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                <i className={`${feature.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}